<template>
  <div>
    <div class="vx-col w-full flex flex-col">
      <div class="vx-row justify-center">
        <AttendanceUserProfileCard :user="user"/>
        <!-- <AttendanceUserRecapGraph :graphData="{label: 'oke'}" /> -->
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full flex flex-col">
        <vx-card title="Data Presensi" class="my-3">
          <div class="w-full mb-5">
            <AttendanceDetailFilter @reloadData="filter = $event" />
          </div>
          <div class="w-full">
            <global-new-wrapper
              :loading="loading"
              :loadingType="'OneLine'"
              :loadingList="5"
              :empty="attendances.data.length == 0"
              :error="error"
            >
              <AttendanceUserRecapCard v-if="filter.status.id == ''" :recapData="attendancesRecap"/>
              <global-table
                @reloadData="pagination.currentPage = $event"
                :currentPage="attendances.current_page"
                :totalPage="attendances.last_page"
              >
                <template #thead>
                  <global-th width="20px">No.</global-th>
                  <global-th>Tanggal Presensi</global-th>
                  <global-th>Clock In</global-th>
                  <global-th>Clock Out</global-th>
                  <global-th>Status</global-th>
                  <global-th>Action</global-th>
                </template>
                <template #tbody>
                  <global-tr v-for="(item, index) in attendances.data" :key="index">
                    <global-td>{{(attendances.current_page-1) * attendances.per_page + index + 1}}</global-td>
                    <global-td><strong>{{moment(item.created_at).format("dddd, DD MMMM YYYY")}}</strong></global-td>
                    <global-td>{{item.start_time ? item.start_time : '---'}}</global-td>
                    <global-td>{{item.end_time ? item.end_time : '---'}}</global-td>
                    <global-td>
                      <AttendanceStatusChip :attendance="item"/>
                    </global-td>
                    <global-td>
                      <vs-button
                        type="border"
                        size="small"
                        icon-pack="feather"
                        icon="icon-edit"
                        @click="showPopupDetail(item.id)"
                      >Detail
                      </vs-button>
                    </global-td>
                  </global-tr>
                </template>
              </global-table>
            </global-new-wrapper>
          </div>
        </vx-card>
      </div>
      <AttendancePopupDetail
        :active.sync="popUpDetail" 
        :attendanceId="selectedAttendanceId" 
      />
    </div>
    <div class="vx-row mt-3">
      <div class="vx-col">
        <vs-button color="primary" class="mb-5" icon-pack="feather" icon="icon-arrow-left" type="border"
          @click="$router.push({name: 'attendance'})">Kembali</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import AttendanceStatusChip from "@/components/chip/AttendanceStatusChip";
import AttendanceDetailFilter from "./components/AttendanceDetailFilter";
import AttendanceUserRecapCard from "./components/AttendanceUserRecapCard";
import AttendanceUserProfileCard from "./components/AttendanceUserProfileCard";
import AttendanceUserRecapGraph from "./components/AttendanceUserRecapGraph";
import AttendancePopupDetail from "./components/AttendancePopupDetail";
import moment from "moment";

export default {
  components: {
    AttendanceStatusChip,
    AttendanceDetailFilter,
    AttendanceUserRecapCard,
    AttendanceUserProfileCard,
    AttendanceUserRecapGraph,
    AttendancePopupDetail
  },
  data() {
    return {
      loading: false,
      error: false,
      popUpDetail: false,
      user: {},
      attendances: {
        data: []
      },
      attendancesRecap: [],
      pagination: {
        currentPage: 1,
        perPage: 30
      },
      filter: {
        status: {id: '', label: 'Semua Status'}, 
        month: {id: '11', label: 'November'},
        year: {id: '2022', label: 'Tahun 2022'},
      },
      selectedAttendanceId: 1
    };
  },
  watch: {
    'pagination.currentPage' : function(){
      this.getAttendanceByUser()
    },
    filter: {
      handler(){
        this.getAttendanceByUser();
      },
      deep: true
    }
  },
  mounted() {
    this.getAttendanceByUser();
  },
  methods: {
    getAttendanceByUser(){
      this.loading = true;
      this.popUpDetail = false;
      this.$http.get("/app/secure/attendance-info/data-by-user", {params : {...this.getParams()}})
      .then(response => {
        this.loading = false;
        this.user = response.data.data.user;
        this.attendances = response.data.data.attendances;
        this.attendancesRecap = response.data.data.attendances_recap;
      })
      .catch(error => {
        this.parseError(error);
      });
    },
    getParams(){
      return  {
        page: this.pagination.currentPage,
        user_id: this.$route.params.user_id,
        month: moment(this.filter.month.id).format("MM"),
        year: moment(this.filter.year.id).format("YYYY"),
        status: this.filter.status.id
      };
    },
    showPopupDetail(attendanceId){
      this.selectedAttendanceId = attendanceId;
      this.popUpDetail = true;
    }
  }
};
</script>